<template>
    <div
        class="book-nav pos-fixed pos-top w-screen d-flex text-yanone flex-align-center z-max px-4"
        :class="{ 'bg-white shadow-5': hasScrolled }"
    >
        <div
            class="cr-logo-full-h"
            :class="{
                'text-default-5': hasScrolled,
                'text-white': !hasScrolled,
            }"
        />
        <a
            class="rounded-full border border-solid border-2 px-3 ml-auto"
            href="/"
            target="_blank"
            :class="{
                'bg-white border-default-5': hasScrolled,
                'border-white text-white': !hasScrolled,
            }"
        >
            Ir à loja
        </a>

        <Navbar
            class="pos-absolute pos-center-x"
            :idle-class="!hasScrolled ? 'text-white' : null"
            indicator-class="bg-primary-5"
        >
            <NavbarPill title="Preâmbulo" value="about" />
            <NavbarPill title="Tom de voz" value="voice" />
            <NavbarPill title="Logomarca" value="logo" />
            <NavbarPill title="Produção de moda" value="fashion" />
            <NavbarPill title="Cores" value="colors" />
            <NavbarPill title="Elementos básicos de composição" value="elements" />
            <NavbarPill title="Hierarquia" value="hierarchy" />
            <NavbarPill title="Ilustrações" value="illustrations" />
        </Navbar>
    </div>
</template>

<script>
    import Navbar from '../../../../../submodules/src/components/navigation/navbar/Navbar.vue';
    import NavbarPill from '../../../../../submodules/src/components/navigation/navbar-pill/NavbarPill.vue';

    export default {
        name: 'BrandBookNavigation',

        components: { Navbar, NavbarPill },

        data() {
            return {
                selectedPill: null,
                hasScrolled: false,
            };
        },

        mounted() {
            this.onScroll();
            window.addEventListener('scroll', this.onScroll, {
                passive: true,
            });
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.onScroll);
        },

        methods: {
            onScroll() {
                const scroll = document.body.scrollTop || document.documentElement.scrollTop;
                this.hasScrolled = scroll > 300;
            },
        },
    };
</script>
